// admin-panel/src/constants.js

export const WHEEL_SECTIONS_CONFIG = [
  { id: 'hilsa', displayText: '45 times', payout: 45, color: '#3b82f6' },
  { id: 'catfish', displayText: '25 times', payout: 25, color: '#6366f1' },
  { id: 'shrimp', displayText: '15 times', payout: 15, color: '#ef4444' },
  { id: 'pufferfish', displayText: '10 times', payout: 10, color: '#f97316' },
  { id: 'cinnamon', displayText: '5 times', payout: 5, color: '#d97706' },
  { id: 'star_anise', displayText: '5 times', payout: 5, color: '#f59e0b' },
  { id: 'bay_leaves', displayText: '5 times', payout: 5, color: '#10b981' },
  { id: 'cardamom', displayText: '5 times', payout: 5, color: '#22c55e' },
];